import gql from "graphql-tag";

export default gql`
  query getCrmIntermediary($query: QueryInput, $offset: OffsetInput) {
    getCrmIntermediary(query: $query, offset: $offset) {
      __typename
      id
      name
      type
      user
    }
  }
`;
